"use client";

/**
 * Table of Contents Component
 *
 * Sticky sidebar for blog posts showing H2 headings with scroll spy.
 * Includes CTA box for conversion.
 */
import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { TableOfContentsProps } from "@/types/blog";
import { useScrollSpy, scrollToHeading } from "./hooks/useScrollSpy";
export default function TableOfContents(t0) {
  const $ = _c(13);
  const {
    headings,
    contentId: t1
  } = t0;
  t1 === undefined ? "content" : t1;
  let t2;
  if ($[0] !== headings) {
    t2 = {
      headings
    };
    $[0] = headings;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const activeId = useScrollSpy(t2);
  const handleClick = _temp;
  if (headings.length === 0) {
    return null;
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-2 text-[16px] font-semibold leading-[150%] text-black">Table of Contents</div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== activeId || $[4] !== headings) {
    let t5;
    if ($[6] !== activeId) {
      t5 = (t6, index) => {
        const {
          id: id_0,
          text
        } = t6;
        const isActive = activeId === id_0;
        return <a key={`${id_0}-${index}`} href={`#${id_0}`} onClick={e_0 => handleClick(e_0, id_0)} className={`relative block py-3 pl-3.5 text-[14px] leading-[140%] transition-[color,background-color,border-color] duration-200 ${index > 0 ? "border-t border-black/10" : ""} ${isActive ? "font-semibold tracking-[-0.02em] text-black" : "font-normal text-black/50 hover:text-black"} `}><span className={`absolute bottom-3 left-0 top-3 w-0.5 transition-colors duration-200 ${isActive ? "bg-black" : "bg-transparent"} `} />{text}</a>;
      };
      $[6] = activeId;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = headings.map(t5);
    $[3] = activeId;
    $[4] = headings;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <nav className="flex flex-col">{t4}</nav>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mt-8 rounded-card-sm bg-cream p-6"><p className="mb-4 text-[14px] leading-[150%] text-black">Ready to grow on autopilot? Outfame's AI brings you real Instagram followers while you sleep. No bots. No password needed.</p><Link href="/setup" className="flex w-full items-center justify-center rounded-pill bg-black px-4 py-3 text-[14px] font-semibold leading-[150%] text-white transition-opacity hover:opacity-90">Start Growing Free</Link></div>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <div className="sticky top-[168px] flex flex-col gap-4">{t3}{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp(e, id) {
  e.preventDefault();
  scrollToHeading(id, 120);
}